var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("status_lunas"),_c('div',{staticClass:"p-x-16 p-y-20 bg-white card-tagihan"},[_vm._t("header"),_vm._t("layanan"),_vm._t("biaya-tambahan"),_vm._t("total-tagihan"),_vm._t("pembayaran"),_vm._t("total-pembayaran"),_vm._t("benefit-non-discount")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }